export default str => str.replace(/<line-break>/g, "\u00A0");
